import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

import { tempSignIn } from '../services';
import { AuthResponse } from '../types';

export const useTempSignIn = ({
  onSuccess,
}: {
  onSuccess: (data: AuthResponse) => void;
}) => {
  return useMutation<
    AuthResponse,
    AxiosError,
    { email: string; emailPin: string }
  >({
    mutationFn: tempSignIn,
    onSuccess,
  });
};
